import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T, ignoreValues: T[]): T {
	const ref = useRef<T>(value);
	useEffect(() => {
		if (ref.current !== value && !ignoreValues.includes(value)) {
			ref.current = value;
		}
	}, [value, ignoreValues]);
	return ref.current;
}
